import { useEffect, type ReactNode } from 'react';

import { useHost } from '@/host/HostContext';

/**
 * Applies host-derived accessibility settings to the root element as
 * data-attributes / CSS classes so tokens.css can react.
 *
 * (Tokens themselves come from CSS variables in tokens.css; this provider
 * just toggles modifiers based on the host config.)
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const { config } = useHost();
  const a11y = config.accessibility;

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute('data-text-size', a11y.textSize);
    html.toggleAttribute('data-high-contrast', a11y.highContrast);
    html.toggleAttribute('data-reduce-motion', a11y.reduceMotion);
    html.setAttribute('lang', config.locale);
  }, [a11y.textSize, a11y.highContrast, a11y.reduceMotion, config.locale]);

  return <>{children}</>;
}
